import * as Yup from "yup"

export const SDCountiesInitialValues = {
	name: "",
}

export const SDCountiesSchema = Yup.object().shape({
	name: Yup.string().required().label("Name").trim(),
})
